"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var styles = {
  "sidebar": "sidebar_3aKXC7"
}; 
require('./Sidebar.css');
var Sidebar = function Sidebar(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "sidebar",
    "data-test-id": "sidebar",
    className: styles.sidebar
  }, children);
};
Sidebar.propTypes = {
  children: _propTypes.default.node
};
var _default = exports.default = Sidebar;
//# sourceMappingURL=Sidebar.js.map